<agr-dialog [data]="data" [verticalSpacing]="true" (cancel)="cancel()">
  <div class="dialog">
    {{ data.text }}
    <div class="flex--row flex--nowrap flex--align-center spacing--margin-top">
      <button
        mat-flat-button
        (click)="overwrite()"
        color="accent"
        class="flex__child--auto spacing--margin-right"
      >
        {{ 'overwrite' | translate }}
      </button>

      <button mat-flat-button (click)="add()" color="primary" class="flex__child--auto">
        {{ 'add' | translate }}
      </button>
    </div>
  </div>
</agr-dialog>
